import { useParams } from 'react-router-dom';

import { convertToDateFormat, calculateAge } from '@/helpers/dateHelpers';

import { useCoach } from '@/data/coach';

const PersonalInfo = () => {
  const params = useParams();
  const coach = useCoach(params.id);

  return (
    <>
      <h2 className="text-2xl font-bold mb-8">Personal Information</h2>
      <div className="grid grid-cols-2 gap-4 mb-6">
        <div>
          <h3 className="text-md font-md text-muted-foreground mb-1">Phone</h3>
          <p>{coach.data.phone}</p>
        </div>
        <div>
          <h3 className="text-md font-md text-muted-foreground mb-1">
            Birth Date
          </h3>
          <p>
            {convertToDateFormat(coach.data.birthDate)}{' '}
            {` (${calculateAge(coach.data.birthDate)} years old)`}
          </p>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4 mb-8">
        <div>
          <h3 className="text-md font-md text-muted-foreground mb-1">
            Address
          </h3>
          <p>{coach.data.addresses[0]?.address}</p>
          <p>
            {coach.data.addresses[0]?.city},{' '}
            {coach.data.addresses[0]?.stateCode}
          </p>
          <p>{coach.data.addresses[0]?.zipCode}</p>
        </div>
        <div>
          <h3 className="text-md font-md text-muted-foreground mb-1">
            Home Town
          </h3>
          <p>{coach.data.hometown || '--'}</p>
        </div>
      </div>
      <div className="mb-8">
        <h3 className="text-md font-md text-muted-foreground mb-1">
          Work Experience
        </h3>
        <p>{coach.data.workExperience}</p>
      </div>
      <div className="mb-8">
        <h3 className="text-md font-md text-muted-foreground mb-1">
          Coaching Regions
        </h3>
        <ul>
          {coach.data.coachRegions.map((coachRegion) => (
            <li key={coachRegion.region.id}>{coachRegion.region.name}</li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default PersonalInfo;
